import * as API from "../api"
import { Report } from "../model/report-model"
import isEmpty from "lodash/isEmpty"

export type RunPreviewData = { [key: string]: CollectionPreviewData[] } // map from collectionId to a list of collectionPreviewDatas

const BARCODE_PREVIEW_REPORT_ID = "collection.barcode_preview_report"
export interface CollectionPreviewData {
    collectionId: string
    time: number
    p1?: number
    estimatedYeild?: number
    meanHiFiQuality?: number
    meanLength?: number
    report?: Report
    basicOrFull: "Basic" | "Full"
}

export const getRunPreviewData = async (runId, collectionIds: string[]): Promise<RunPreviewData> => {
    const reportFilesResponse = await API.nRunReports(runId)
    const reportFiles = reportFilesResponse.data
    const previewReportFiles = reportFiles.filter( report => report.reportTypeId === BARCODE_PREVIEW_REPORT_ID)
    const previewReportPromises = previewReportFiles.map( report =>
        API.aDatastoreFileDownload(report.dataStoreFile.uuid).then( response => response.data as Report)
    )
    const previewReports = await Promise.all(previewReportPromises)
    const runPreviewData: RunPreviewData = {}
    for (let colId of collectionIds) {
        const reportsForThisCollection = previewReports.filter( report => {
            if (isEmpty(report.dataset_uuids)) {
                return false
            }
            return report.dataset_uuids.includes(colId)
        })
        if (!isEmpty(reportsForThisCollection)) {
            const previewsForThisCollection = reportsForThisCollection.map(report =>
                getCollectionPreviewDataFromReport(colId, report))
            previewsForThisCollection.sort( (preview1, preview2) => {
                return preview1.time - preview2.time
            })
            runPreviewData[colId] = previewsForThisCollection
        }
    }
    return runPreviewData
}

export const getCollectionPreviewDataFromReport = (collectionId: string, report: Report): CollectionPreviewData => {
    const getValue = (field: string) => {
        const reportAttr = report.attributes.find( attr => attr.id === field)
        return reportAttr ? reportAttr.value : null
    }
    return{
        collectionId: collectionId,
        time: getValue("time_hours"),
        p1:  getValue("p1_percent"),
        estimatedYeild:  getValue("estimated_hifi_yield"),
        meanHiFiQuality: getValue("mean_hifi_quality"),
        meanLength: getValue("mean_length"),
        basicOrFull: getValue("workflow"),
        report: report
    }
}
